// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"535":"login","826":"index"}[chunkId] || chunkId) + "." + {"223":"05e47d14","535":"a01bfd34","826":"9786ad23"}[chunkId] + ".js";
};